import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Box = styled.div`
  background-color: ${({ theme }) => theme.palette.primary.background};
  width: 100vw;
`;

export const InnerBox = styled.div`
  padding: 0 15px 15px;
`;

export const Amount = styled(Typography.Body)`
  margin-top: 5px;
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const AmountSkeleton = styled.div`
  margin-top: 5px;
`;
